module.exports = __webpack_public_path__ + "static/img/pen.08bad40d.png";